import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn, FlexRow } from "./common.styles";
import { fontWeights } from "healthex-common/weights";
import LoginOutlined from "@mui/icons-material/LoginOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
export const LoginLocationContainer = styled(FlexColumn) `
    width: 100%;
    gap: 24px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
`;
export const LocationCard = styled(FlexColumn) `
    padding: 32px 24px;
    gap: 16px;
    border: 2px solid ${colors.blue_10};
    border-radius: 12px;
    background-color: ${colors.white_main};
    align-items: center;
    align-self: center;
`;
export const LoginLocationIcon = styled(LoginOutlined) `
    && {
        width: 40px;
        height: 40px;
        color: ${colors.blue_main};
    }
`;
export const LocationLogoContainer = styled.div `
    width: 80px;
    height: 80px;
    min-width: 80px;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    border: 1px solid ${colors.black_12};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.white_main};
`;
export const LocationLogo = styled.img `
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 8px;
`;
export const LocationFallbackIcon = styled(FlexColumn) `
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: ${colors.blue_30};
    align-items: center;
    align-self: center;
    justify-content: center;
    font-size: 32px;
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.white_main};
    text-transform: uppercase;
`;
export const LocationName = styled.div `
    font-size: 18px;
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    text-align: center;
    line-height: 1.4;
`;
export const LocationErrorText = styled.div `
    font-size: 14px;
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.navy_main};
    text-align: center;
    line-height: 1.4;
`;
export const WarningContainer = styled(FlexRow) `
    background-color: ${colors.blue_5};
    border: 1px solid ${colors.blue_30};
    border-radius: 12px;
    padding: 24px;
    gap: 8px;
    justify-content: space-between;
`;
export const ErrorContainer = styled(FlexRow) `
    background-color: ${colors.tulip_12};
    border-radius: 12px;
    padding: 12px;
`;
export const LaunchIconContainer = styled(FlexColumn) `
    justify-content: center;
`;
export const LaunchIcon = styled(OpenInNewIcon) `
    width: 24px;
    height: 24px;
`;
export const BannerMessaging = styled(FlexColumn) `
    background-color: ${colors.sunset_12};
    border-radius: 12px;
    padding: 12px;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
`;
export const BannerText = styled.p `
    font-size: 13px;
    color: ${colors.black_light};
    text-align: center;
    margin: 0;
    width: 100%;
`;
